// extracted by mini-css-extract-plugin
export default {"BoxStepInfoContainer":"BoxInfo_BoxStepInfoContainer__o0y+F","TextoInfo":"BoxInfo_TextoInfo__wqgM6"};